import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '@/index.css'
import ResetPasswordSuccessScreen from '../screens/ResetPasswordSuccessScreen'
import { ensureUniversalLoginContext } from '@/utils/helpers/universalLoginContext.ts'

async function bootstrap() {
  await ensureUniversalLoginContext('reset-password-success')
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <ResetPasswordSuccessScreen />
    </StrictMode>,
  )
}

bootstrap()
